import React, { useEffect, useState } from "react";
import axios from "axios";
import "./company.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import ReactTooltip from 'react-tooltip';




function Company() {
    const [stocks, setStocks] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [companyData, setCompanyData] = useState({
        companyName: "",
        companyPoint: 0,
        companyStatus: "BULLISH"
    });
    const [editCompanyData, setEditCompanyData] = useState({
        active: true,
        companyId: "",
        companyName: "",
        companyCode: "",
        companyPoint: 0,
    })
    const [isEditing, setIsEditing] = useState(false);
    // const [activeTab, setActiveTab] = useState("NIFTY");
    const [activeTab, setActiveTab] = useState(() => {
        return localStorage.getItem("companyActiveTab") || "NIFTY";
    });
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        localStorage.setItem("companyActiveTab", tab);
    };

    // Bank Nifty Add Company states
    const [bankCompanyData, setBankCompanyData] = useState({
        companyName: "",
        companyPoint: 0
    });
    const [showBankModal, setShowBankModal] = useState(false);
    const [isEditingBank, setIsEditingBank] = useState(false);
    const [editBankCompanyData, setEditBankCompanyData] = useState({
        companyId: "",
        companyName: "",
        companyPoint: 0,
        active: true
    });

    // Function to generate next company code
    const getNextCompanyCode = () => {
        if (!stocks.length) return "#C00001";

        const lastCompany = stocks.reduce((max, company) => {
            const num = parseInt(company.companyCode.replace("#C", ""), 10);
            return num > max ? num : max;
        }, 0);

        return `#C${String(lastCompany + 1).padStart(5, "0")}`;
    };

    // Fetch company list on component mount
    useEffect(() => {
        // Clear previous stocks to avoid flicker
        setStocks([]);

        // Decide API URL
        const apiUrl =
            activeTab === "NIFTY"
                ? "https://prod-erp.nifty10.in/get/company"  // Production API
                : "https://prod-erp.nifty10.in/api/banknifty/company/list";  // Backend proxy for dev

        axios
            .get(apiUrl)
            .then((response) => {
                let fetchedStocks = response.data.data || [];
                setStocks(
                    fetchedStocks.sort((a, b) =>
                        (a.companyName || "").localeCompare(b.companyName || "")
                    )
                );
            })
            .catch((error) => console.error("Error fetching data:", error));
    }, [activeTab]);




    // Handle input change in modal
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCompanyData((prev) => ({
            ...prev,
            [name]: name === "companyPoint" ? parseFloat(value) || 0 : value
        }));
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;

        setEditCompanyData((prev) => ({
            ...prev,
            active: name === "companyStatus" ? value === "true" : prev.active,
            companyPoint: name === "companyPoint" ? (value ? parseFloat(value) : "") : prev.companyPoint
        }));
    };






    const handleEditConfirmation = (stock) => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
        });

        swalWithBootstrapButtons
            .fire({
                title: `Edit ${stock.companyName}?`,
                text: `You are about to edit details for ${stock.companyName}.`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                reverseButtons: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    if (activeTab === "NIFTY") {
                        setIsEditing(true);
                        setEditCompanyData({
                            companyId: stock.companyId,
                            companyName: stock.companyName,
                            companyCode: stock.companyCode,
                            companyPoint: stock.companyPoint,
                            active: stock.active
                        });
                    } else {
                        setIsEditingBank(true);
                        setEditBankCompanyData({
                            companyId: stock.companyId,
                            companyName: stock.companyName,
                            companyPoint: stock.companyPoint,
                            active: stock.active
                        });
                    }
                }
            });
    };


    // Open modal and reset form data
    const handleAddCompany = () => {
        setCompanyData({
            active: true,
            companyCode: getNextCompanyCode(),
            companyName: "",
            companyPoint: 0,
            companyStatus: "BULLISH",
            createdBy: "556c3d52-e18d-11ef-9b7f-02fd6cfaf985",
            liveBB: false,
        });
        setShowModal(true);
    };

    const handleEditCompanySubmit = async (e) => {
        e.preventDefault();
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
        });

        try {
            const payload = {
                active: editCompanyData.active,
                companyId: editCompanyData.companyId,
                companyPoint: parseFloat(editCompanyData.companyPoint) || 0,
                companyName: editCompanyData.companyName
            };

            const response = await axios.post(
                "https://prod-erp.nifty10.in/company/update",
                payload,
                { headers: { "accept": "application/json", "Content-Type": "application/json" } }
            );
            toast.success("Company added successfully!", { position: "top-right" });

            setIsEditing(false);

            if (response.data?.data) {
                setStocks((prevStocks) =>
                    response.data.data.active
                        ? prevStocks
                            .map(company =>
                                company.companyId === response.data.data.companyId ? response.data.data : company
                            )
                            .sort((a, b) => (a.companyName || "").localeCompare(b.companyName || ""))
                        : prevStocks.filter(company => company.companyId !== response.data.data.companyId) // Remove inactive company
                );
            }
            swalWithBootstrapButtons.fire({
                title: "Updated.!",
                text: "Company changes Updated successfully",
                icon: "success",
            });

        } catch (error) {
            console.error("Error adding company:", error.response?.data || error.message);
            toast.error("Failed to add company. Try again!", { position: "top-right" });
            swalWithBootstrapButtons.fire({
                title: "Oops",
                text: "Something Went Wrong..!",
                icon: "error",
            });
        }
    };


    // Submit Edit company data
    const handleAddCompanySubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                active: companyData.active, // Ensuring correct active status
                companyName: companyData.companyName.trim().toUpperCase(),
                companyPoint: parseFloat(companyData.companyPoint) || 0,
                createdBy: "556c3d52-e18d-11ef-9b7f-02fd6cfaf985"
            };

            const response = await axios.post(
                "https://prod-erp.nifty10.in/company/create",
                payload,
                { headers: { "Accept": "application/json", "Content-Type": "application/json" } }
            );
            toast.success("Company added successfully!", { position: "top-right" });

            setTimeout(() => {
                setIsEditing(false); // Ensure the modal closes properly
                if (response.data?.data) {
                    setStocks((prevStocks) =>
                        [...prevStocks, response.data.data]
                            .filter(company => company.companyName) // Ensure companyName is not null
                            .sort((a, b) => (a.companyName || "").localeCompare(b.companyName || ""))
                    );
                }
            }, 2000);


        } catch (error) {
            console.error("Error adding company:", error.response?.data || error.message);
            toast.error("Failed to add company. Try again!", { position: "top-right" });
        }
    };
    const handleBankEditChange = (e) => {
        const { name, value } = e.target;
        setEditBankCompanyData((prev) => ({
            ...prev,
            [name]: name === "companyPoint"
                ? (value ? parseFloat(value) : 0)
                : name === "active"
                    ? value === "true"
                    : value
        }));
    };

    const handleEditBankCompanySubmit = async (e) => {
        e.preventDefault();
        try {
            // Payload sent to your backend
            const payload = {
                companyId: editBankCompanyData.companyId,      // string
                companyName: editBankCompanyData.companyName,  // string
                companyPoint: Number(editBankCompanyData.companyPoint) || 0, // number
                active: editBankCompanyData.active === true
                // ❌ do NOT include updateLogs, backend will add it
            };

            const response = await axios.post(
                "https://prod-erp.nifty10.in/api/banknifty/company/update",
                payload
            );

            if (response.status === 200 && response.data?.data) {
                toast.success("Company updated successfully!");
                setIsEditingBank(false);

                setStocks((prev) =>
                    prev.map((c) =>
                        c.companyId === response.data.data.companyId ? response.data.data : c
                    )
                );
            } else {
                toast.error("Something went wrong while updating!");
            }
        } catch (error) {
            console.error("Error updating Bank Nifty company:", error);
            toast.error("Failed to update company. Try again!");
        }
    };



    return (

        <div id="companyContainer" className="company-container">
            <div>
                <ToastContainer position="top-right" style={{ marginTop: "65px" }} />
                <button
                    className={`tab-button ${activeTab === "NIFTY" ? "active" : ""}`}
                    onClick={() => handleTabClick("NIFTY")}
                >
                    Nifty
                </button>
                <button
                    className={`tab-button ${activeTab === "BANKNIFTY" ? "active" : ""}`}
                    onClick={() => handleTabClick("BANKNIFTY")}
                >
                    Bank Nifty
                </button>

            </div>
            {activeTab === "NIFTY" ? (
                <>
                    <h1 style={{ marginTop: "10px" }}>NIFTY 50 STOCKS</h1>


                    <div className="add-company-btn">
                        <button className="company-submit-button" onClick={handleAddCompany}>
                            ADD COMPANY
                        </button>
                    </div>

                    {isEditing && (
                        <>
                            <div className="company-popup-overlay"></div>
                            <div className="company-popup">
                                <h2>Edit Company</h2>
                                <form onSubmit={handleEditCompanySubmit}>
                                    <div className="company-form-group">
                                        <label htmlFor="companyName">Company Name</label>
                                        <input style={{width:"100%"}}
                                            type="text"
                                            id="companyName"
                                            name="companyName"
                                            placeholder="Enter Company Name"
                                            value={editCompanyData.companyName.toUpperCase()}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                    </div>

                                    {/* ❌ REMOVE this company code field */}
                                    {/* <div className="company-form-group">
          <label htmlFor="companyCode">Company Code</label>
          <input style={{width:"100%"}} type="text" id="companyCode" name="companyCode" value={editCompanyData.companyCode} readOnly />
        </div> */}

                                    <div className="company-form-group">
                                        <label>Active</label>
                                        <div className="company-radio-group">
                                            <input style={{width:"100%"}}
                                                type="radio"
                                                name="companyStatus"
                                                value="true"
                                                checked={editCompanyData.active === true}
                                                className="company-radio-input"
                                                onChange={handleEditChange}
                                            />
                                            <label className="company-radio-label">True</label>

                                            <input style={{width:"100%"}}
                                                type="radio"
                                                name="companyStatus"
                                                value="false"
                                                checked={editCompanyData.active === false}
                                                className="company-radio-input"
                                                onChange={handleEditChange}
                                            />
                                            <label className="company-radio-label">False</label>
                                        </div>
                                    </div>

                                    <div className="company-form-group">
                                        <label htmlFor="companyPoint">Company Point</label>
                                        <input style={{width:"100%"}}
                                            type="number"
                                            step="0.01"
                                            id="companyPoint"
                                            name="companyPoint"
                                            placeholder="Enter Points"
                                            value={editCompanyData.companyPoint}
                                            onChange={handleEditChange}
                                            required
                                        />
                                    </div>

                                    <div className="modal-actions">
                                        <button type="button" className="holiday-cancel-btn" onClick={() => setIsEditing(false)}>
                                            Cancel
                                        </button>
                                        <button type="submit" className="holiday-submit-btn">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </>
                    )}


                    {showModal && (
                        <>
                            <div className="company-popup-overlay"></div>
                            <div className="company-popup">
                                <h2>Add Company</h2>
                                <form onSubmit={handleAddCompanySubmit}>
                                    <div className="company-form-group">
                                        <label htmlFor="companyName">Company Name</label>
                                        <input style={{width:"100%"}}
                                            type="text"
                                            id="companyName"
                                            name="companyName"
                                            placeholder="Enter Company Name"
                                            value={companyData.companyName}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    {/* ❌ REMOVE this company code field */}
                                    {/* <div className="company-form-group">
          <label htmlFor="companyCode">Company Code</label>
          <input style={{width:"100%"}} type="text" id="companyCode" name="companyCode" value={companyData.companyCode} readOnly />
        </div> */}

                                    {/* ❌ REMOVE status selection */}
                                    {/* <div className="company-form-group">
          <label>Status</label>
          <div className="company-radio-group">
            <input style={{width:"100%"}}
              type="radio"
              name="companyStatus"
              value="BULLISH"
              checked={companyData.companyStatus === "BULLISH"}
              className="company-radio-input"
              onChange={handleChange}
            />
            <label className="company-radio-label">Bullish</label>

            <input style={{width:"100%"}}
              type="radio"
              name="companyStatus"
              value="BEARISH"
              checked={companyData.companyStatus === "BEARISH"}
              className="company-radio-input"
              onChange={handleChange}
            />
            <label className="company-radio-label">Bearish</label>
          </div>
        </div> */}

                                    <div className="company-form-group">
                                        <label htmlFor="companyPoint">Company Point</label>
                                        <input style={{width:"100%"}}
                                            type="number"
                                            step="0.25"
                                            min="0"
                                            id="companyPoint"
                                            name="companyPoint"
                                            placeholder="Enter Points"
                                            value={companyData.companyPoint}
                                            onChange={(e) => {
                                                let value = e.target.value;

                                                if (value === "" || parseFloat(value) < 0) return;
                                                if (value.length > 1 && value.startsWith("0") && !value.startsWith("0.")) {
                                                    value = value.replace(/^0+/, "");
                                                }

                                                setCompanyData((prev) => ({
                                                    ...prev,
                                                    companyPoint: value
                                                }));
                                            }}
                                            required
                                        />
                                    </div>

                                    <div className="modal-actions">
                                        <button type="button" className="holiday-cancel-btn" onClick={() => setShowModal(false)}>
                                            Cancel
                                        </button>
                                        <button type="submit" className="holiday-submit-btn">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </>
                    )}



                    <ul className="company-stocks-container">
                        {stocks.map((stock, index) => (
                            <li
                                key={index}
                                className="company-stock-box"
                                data-tip
                                data-for={`tooltip-${index}`}
                                onClick={() => handleEditConfirmation(stock)}
                            >
                                <span className="company-stock-symbol">{stock.companyName}</span>
                                <span className="company-stock-value">
                                    {isNaN(stock.companyPoint) ? "0" : Math.max(Number(stock.companyPoint), 0)}
                                </span>

                                <ReactTooltip className="company-tool-tip" id={`tooltip-${index}`} effect="solid" place={index < 6 ? "bottom" : "top"} backgroundColor="#333">
                                    <div style={{ textAlign: "left" }}>
                                        <p><strong>Code:</strong> {stock.companyCode}</p>
                                        <p><strong>Status:</strong> {stock.companyStatus}</p>
                                        <p><strong>Active:</strong> {stock.active ? "Yes" : "No"}</p>
                                        <p><strong>Created:</strong> {new Date(stock.createdDate).toLocaleString()}</p>
                                        <p><strong>Modified:</strong> {new Date(stock.modifiedDate).toLocaleString()}</p>
                                        <p className="company-update">Click on the company to update </p>
                                    </div>
                                </ReactTooltip>
                            </li>



                        ))}
                    </ul>
                </>
            ) : (
                <div className="bank-nifty-page">
                    <h1 style={{ marginTop: "10px" }}>BANK NIFTY STOCKS</h1>
                    <div className="add-company-btn">
                        <button
                            className="company-submit-button"
                            onClick={() => setShowBankModal(true)}
                        >
                            ADD COMPANY
                        </button>
                    </div>
                    <ul
                        className={`company-stocks-container ${activeTab === "BANKNIFTY" ? "banknifty-grid" : ""
                            }`}
                    >
                        {stocks.map((stock, index) => (
                            <li
                                key={index}
                                className={`company-stock-box ${activeTab === "BANKNIFTY" ? "banknifty-box" : ""
                                    }`}
                                data-tip
                                data-for={`tooltip-${index}`}
                                onClick={() => handleEditConfirmation(stock)}
                            >
                                <span className="company-stock-symbol">{stock.companyName}</span>
                                <span className="company-stock-value">
                                    {isNaN(stock.companyPoint) ? "0" : Math.max(Number(stock.companyPoint), 0)}
                                </span>
                            </li>
                        ))}
                    </ul>
                    {showBankModal && (
                        <>
                            <div className="company-popup-overlay"></div>
                            <div className="company-popup">
                                <h2>Add Bank Nifty Company</h2>

                                <form
                                    onSubmit={async (e) => {
                                        e.preventDefault();
                                        try {
                                            const payload = {
                                                companyName: bankCompanyData.companyName.trim().toUpperCase(),
                                                companyPoint: parseFloat(bankCompanyData.companyPoint) || 0,
                                                active: true,                   // or get from radio buttons
                                                companyStatus: "BULLISH",       // can be dynamic if needed
                                                createdBy: "556c3d52-e18d-11ef-9b7f-02fd6cfaf985",
                                                liveBB: true
                                                // ❌ no updateLogs, backend will add it
                                            };

                                            console.log("Payload sent to backend:", payload);

                                            const response = await axios.post(
                                                "https://prod-erp.nifty10.in/api/banknifty/company/create",
                                                payload
                                            );

                                            toast.success("Bank Nifty company added successfully!", { position: "top-right" });
                                            setShowBankModal(false);

                                            if (response.data?.data) {
                                                setStocks((prev) =>
                                                    [...prev, response.data.data].sort((a, b) =>
                                                        (a.companyName || "").localeCompare(b.companyName || "")
                                                    )
                                                );
                                            }
                                        } catch (error) {
                                            console.error("Error adding Bank Nifty company:", error);
                                            toast.error("Failed to add company. Try again!", { position: "top-right" });
                                        }
                                    }}
                                >

                                    {/* ✅ Company Name */}
                                    <div className="company-form-group">
                                        <label htmlFor="bankCompanyName">Company Name</label>
                                        <input style={{width:"100%"}}
                                            type="text"
                                            id="bankCompanyName"
                                            name="companyName"
                                            placeholder="Enter Company Name"
                                            value={bankCompanyData.companyName}
                                            onChange={(e) =>
                                                setBankCompanyData((prev) => ({
                                                    ...prev,
                                                    companyName: e.target.value
                                                }))
                                            }
                                            required
                                        />
                                    </div>

                                    {/* ✅ Company Points */}
                                    <div className="company-form-group">
                                        <label htmlFor="bankCompanyPoint">Company Point</label>
                                        <input style={{width:"100%"}}
                                            type="number"
                                            step="0.25"
                                            min="0"
                                            id="bankCompanyPoint"
                                            name="companyPoint"
                                            placeholder="Enter Points"
                                            value={bankCompanyData.companyPoint}
                                            onChange={(e) =>
                                                setBankCompanyData((prev) => ({
                                                    ...prev,
                                                    companyPoint: e.target.value
                                                }))
                                            }
                                            required
                                        />
                                    </div>

                                    <div className="modal-actions">
                                        <button
                                            type="button"
                                            className="holiday-cancel-btn"
                                            onClick={() => setShowBankModal(false)}
                                        >
                                            Cancel
                                        </button>
                                        <button type="submit" className="holiday-submit-btn">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </>
                    )}
                    {isEditingBank && (
                        <>
                            <div className="company-popup-overlay"></div>
                            <div className="company-popup">
                                <h2>Edit Bank Nifty Company</h2>
                                <form onSubmit={handleEditBankCompanySubmit}>
                                    <div className="company-form-group">
                                        <label>Company Name</label>
                                        <input style={{width:"100%"}}
                                            type="text"
                                            value={editBankCompanyData.companyName}
                                            readOnly
                                        />
                                    </div>

                                    <div className="company-form-group">
                                        <label>Active</label>
                                        <div className="company-radio-group">
                                            <input style={{width:"100%"}}
                                                type="radio"
                                                name="active"
                                                value="true"
                                                checked={editBankCompanyData.active === true}
                                                onChange={handleBankEditChange}
                                            />
                                            <label>True</label>
                                            <input style={{width:"100%"}}
                                                type="radio"
                                                name="active"
                                                value="false"
                                                checked={editBankCompanyData.active === false}
                                                onChange={handleBankEditChange}
                                            />
                                            <label>False</label>
                                        </div>
                                    </div>

                                    <div className="company-form-group">
                                        <label>Company Point</label>
                                        <input style={{width:"100%"}}
                                            type="number"
                                            step="0.25"
                                            name="companyPoint"
                                            value={editBankCompanyData.companyPoint}
                                            onChange={handleBankEditChange}
                                            required
                                        />
                                    </div>

                                    <div className="modal-actions">
                                        <button type="button" className="holiday-cancel-btn" onClick={() => setIsEditingBank(false)}>
                                            Cancel
                                        </button>
                                        <button type="submit" className="holiday-submit-btn">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </>
                    )}

                </div>
            )}
        </div>
    );
}

export default Company;
